import React, { useEffect, useState } from "react";
import { Modal, Table, Avatar } from "antd";
import { UserOutlined } from "@ant-design/icons";
// import { formatDateByLocale } from "../../../utils/dateFormat";
import { gql, useLazyQuery } from "@apollo/client";

const GET_ACTIVE_USERS = gql`
  query getActiveUsers($challengeId: String!, $weekStartDate: DateTime!) {
    getActiveUsers(challengeId: $challengeId, weekStartDate: $weekStartDate) {
      lastActivityDate
      user {
        _id
        name
        profile_image
        lastLoginAt
      }
    }
  }
`;

export default function ActiveUsersModal({
  open,
  challenge,
  weekStartDate,
  onCancel,
}) {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [getActiveUsers, { data, loading: queryLoading }] =
    useLazyQuery(GET_ACTIVE_USERS);

  useEffect(() => {
    if (open && challenge?._id && weekStartDate) {
      setLoading(true);
      getActiveUsers({
        variables: {
          challengeId: challenge._id,
          weekStartDate: weekStartDate,
        },
      });
    }
  }, [open, challenge?._id, weekStartDate, getActiveUsers]);

  useEffect(() => {
    if (data?.getActiveUsers) {
      setList(data.getActiveUsers || []);
      setLoading(false);
    }
  }, [data]);

  useEffect(() => {
    if (queryLoading !== undefined) {
      setLoading(queryLoading);
    }
  }, [queryLoading]);

  const columns = [
    {
      title: "User",
      dataIndex: "user.name",
      key: "user",
      render: (_, record) => (
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <Avatar
            src={record.user.profile_image}
            icon={<UserOutlined />}
            style={{ backgroundColor: "#1890ff" }}
          />
          <div style={{ fontWeight: 500, fontSize: "14px" }}>
            {record.user.name}
          </div>
        </div>
      ),
    },
    // {
    //   title: "Last Active Date",
    //   dataIndex: "lastActiveDate",
    //   key: "lastActiveDate",
    //   render: (date) => formatDateByLocale(date),
    // },
    // {
    //   title: "Last Login",
    //   dataIndex: "user.lastLoginAt",
    //   key: "lastLoginAt",
    //   render: (date) => formatDateByLocale(date),
    // },
  ];

  return (
    <Modal
      title={
        "Active Users"
      }
      open={open}
      onCancel={onCancel}
      footer={null}
      width={800}
    >
      <Table
        columns={columns}
        dataSource={list}
        rowKey={(record) => record._id}
        loading={loading}
        size="small"
        total={list.length}
      />
    </Modal>
  );
}
